import { c as _c } from "react/compiler-runtime";
import AppLink from '@/components/elementary/AppLink';
import { Tag } from '@/components/elementary/Tag';
import { ArrowRight } from '@/components/icons/ArrowRight';
import { BasicImage, type BasicImageProps } from '@/components/page-builder/components/BasicImage';
import Heading from '@/components/typography/Heading';
import { Paragraph } from '@/components/typography/Paragraph';
import { cn } from '@/lib/styles';
import { LIBRARY_COMPONENT_TEST_IDS } from '@/lib/test-ids';
import type { GridCardProps } from '@/types/general';
import styles from './LibraryItem.module.css';
export const LibraryItem = t0 => {
  const $ = _c(33);
  const {
    loading,
    fetchPriority,
    entryItem
  } = t0;
  const {
    tag,
    image,
    categories,
    title,
    link
  } = entryItem;
  let t1;
  if ($[0] !== entryItem.link) {
    t1 = entryItem.link ?? {
      href: "#"
    };
    $[0] = entryItem.link;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = entryItem.link?.newTab ?? true;
  let t3;
  if ($[2] !== entryItem.image || $[3] !== fetchPriority || $[4] !== image?.media?.url || $[5] !== loading) {
    t3 = image?.media?.url && <div className="relative overflow-hidden rounded-xl w-full xl:max-w-75 aspect-3/2"><BasicImage fill={true} component={entryItem.image} className="object-cover" sizes="(min-width: 1280px) 300px, (min-width: 640px) 450px, 100vw" fetchPriority={fetchPriority} loading={loading} /></div>;
    $[2] = entryItem.image;
    $[3] = fetchPriority;
    $[4] = image?.media?.url;
    $[5] = loading;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== tag) {
    t4 = tag && <Tag name={tag.name} variant={tag.variant?.variant} size="small" customColors={tag.customColors ? {
      backgroundColor: tag.customColors.backgroundColor?.color,
      textColor: tag.customColors.textColor?.color,
      borderColor: tag.customColors.borderColor?.color
    } : undefined} className="w-fit" />;
    $[7] = tag;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== categories) {
    t5 = categories?.map(_temp);
    $[9] = categories;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="flex items-center gap-2">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn("line-clamp-3", styles["library-title"]);
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== title) {
    t8 = <Heading tag="h3" className={t7}>{title}</Heading>;
    $[15] = title;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = link?.label;
  let t10;
  if ($[17] !== t9) {
    t10 = <Paragraph fontSize="bodyRegularMedium" className="underline font-bold group-hover/library-item:text-peach-600 group-focus-visible/library-item:text-peach-600 group-active/library-item:text-peach-600 transition-colors ease-in-out duration-200 text-inherit">{t9}</Paragraph>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ArrowRight className="size-4 group-hover/library-item:text-peach-600 group-focus-visible/library-item:text-peach-600 group-active/library-item:text-peach-600 ml-0 group-hover/library-item:ml-1 transition-[margin] duration-200" />;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10) {
    t12 = <div className="flex items-center gap-1 mt-auto">{t10}{t11}</div>;
    $[20] = t10;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t6 || $[24] !== t8) {
    t13 = <div className="flex flex-col gap-3 flex-1">{t6}{t8}{t12}</div>;
    $[22] = t12;
    $[23] = t6;
    $[24] = t8;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13 || $[27] !== t3) {
    t14 = <div className="group/library-item flex flex-col gap-6 size-full">{t3}{t13}</div>;
    $[26] = t13;
    $[27] = t3;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t1 || $[30] !== t14 || $[31] !== t2) {
    t15 = <AppLink link={t1} openExternalInNewTab={t2} data-test-id={LIBRARY_COMPONENT_TEST_IDS.LINK} className="h-full items-baseline">{t14}</AppLink>;
    $[29] = t1;
    $[30] = t14;
    $[31] = t2;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
};
function _temp(category) {
  return <Paragraph key={category.documentId} className="text-neutral-500" fontSize="bodyRegularMedium">{category?.title}</Paragraph>;
}